export default __webpack_public_path__ + "static/media/CountDownImage3.76f44b99.jpg";